"use strict";

import angular from "angular";
import "./analysis-plus-request-plan-dialog.scss";
import { Accounting } from "../../../../../../gateway/Accounting/Accounting";
import { UserDataAdapter } from "../../../../../../presentation/adpters/UserDataAdapter";

export class AnalysisPlusRequestPlanDialogCtrl {
    Accounting = new Accounting();
    user = new UserDataAdapter().user();
    constructor($mdDialog, locals, toast) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.toast = toast;
    }

    $onInit() {}

    onRequestAnalysisPlus() {
        this.Accounting.requestProductGrowth({
            accountingId: this.locals.accountingEntity.props._id,
            pckge: "Análise Plus",
            licenses: 1,
            email: this.user.username,
            options: {
                addedValue: "0",
                period: ""
            }
        });
        const options = {
            message: `Solicitação da Análise Plus enviada com sucesso`,
            after: {
                then: (result) => {},
                catch: (error) => {}
            },
            extOptions: {
                hideDelay: 3000
            }
        };
        this.toast.snackbar(options);
        this.$mdDialog.hide();
    }
}

AnalysisPlusRequestPlanDialogCtrl.$inject = ["$mdDialog", "locals", "toast"];

angular
    .module("nucont.accounting.company.dashboards")
    .controller("AnalysisPlusRequestPlanDialogCtrl", AnalysisPlusRequestPlanDialogCtrl);
